import React, { useEffect, useState } from "react";
import Head from "next/head";
import HeroSection from "../components/Neet-pg/HeroSection";
import Explore from "../components/Neet-pg/Explore";
import Overview from "../components/Neet-pg/Overview";
import BlogsVisible from "../components/Neet-pg/blogsVisible";
import Plans from "../components/Neet-pg/Plans";
import TestimonialCarousel from "@/components/Neet-pg/TestimonialCarousel";
import Faqs from "@/components/Neet-pg/faq";
import BlackFridayOffer from "../components/Neet-pg/BlackFridayOffer";
//import WebinarModal from "../components/WebinarModal";
import OneToOneSession from "../components/OneToOneSessionModal";
import axios from "axios";

export default function NeetPgPage() {
	const [priceBasic, setPriceBasic] = useState(1980);
	//const [showWebinarModal, setShowWebinarModal] = useState(false);
	const [showOneToOneModal, setShowOneToOneModal] = useState(false);

	useEffect(() => {
		async function fetchPricing() {
			try {
				const API_URL = process.env.NEXT_PUBLIC_API_URL || "";
				if (!API_URL) return;
				const res = await axios.get(`${API_URL}/api/fetch-pgservices-data`);
				if (res?.data?.data?.length > 0) {
					const fetched = res.data.data[0];
					setPriceBasic(fetched?.priceDetails?.pgbasic || 1980);
				}
			} catch (err) {}
		}
		fetchPricing();
	}, []);

	// Show webinar modal after 5 seconds on every visit
	// useEffect(() => {
	// 	const timer = setTimeout(() => {
	// 		setShowWebinarModal(true);
	// 	}, 5000); // 5 seconds delay

	// 	return () => clearTimeout(timer);
	// }, []);
		useEffect(() => {
		const timer = setTimeout(() => {
			setShowOneToOneModal(true);
		}, 5000); // 5 seconds delay

		return () => clearTimeout(timer);
	}, []);


	return (
		<>
			<Head>
				<title>NEET PG 2026 – Exam, Counselling, Cutoff & Admission Guide</title>
				<meta
					name="description"
					content="Complete NEET PG 2026 guide with eligibility, exam pattern, counselling process, cutoff trends, seat allotment insights, and tips to secure MD/MS/PG Diploma seats."
				/>
				<meta
					name="keywords"
					content="NEET PG counselling, NEET PG 2026, seat allotment, cutoff predictor, NEET PG colleges, MD MS admissions, seat matrix, counselling guidance, PG medical seats"
				/>
				{/* canonical URL */}
				<link rel="canonical" href="https://neetsupport.com/neet-pg" />
				<meta property="og:url" content="https://neetsupport.com/neet-pg" />
				{/* NEET PG Page Schema Markup (Google-friendly JSON-LD) */}
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify({
							"@context": "https://schema.org",
							"@graph": [
								{
									"@type": "Organization",
									"@id": "https://neetsupport.com/#organization",
									"name": "NEET Support",
									"url": "https://neetsupport.com/",
									"logo": {
										"@type": "ImageObject",
										"url": "https://neetsupport.com"
									},
									"email": "info@neetsupport.com",
									"telephone": ["+91 9560465351", "+91 9910989253"],
									"address": [
										{
											"@type": "PostalAddress",
											"streetAddress": "Ground Floor, C-127, C Block, Sector 63",
											"addressLocality": "Noida",
											"addressRegion": "Uttar Pradesh",
											"postalCode": "201301",
											"addressCountry": "IN"
										},
									]
								},
								{
									"@type": "WebSite",
									"@id": "https://neetsupport.com/#website",
									"url": "https://neetsupport.com/",
									"name": "NEET Support",
									"publisher": {
										"@id": "https://neetsupport.com/#organization"
									}
								},
								{
									"@type": "WebPage",
									"@id": "https://neetsupport.com/neet-pg#webpage",
									"url": "https://neetsupport.com/neet-pg",
									"name": "NEET PG Counselling 2026 | Seat Allotment, College Cutoff & Tools",
									"description": "NEET PG counselling guidance with tools for cutoffs, allotment insights, seat matrix, fees/stipend/bond comparison, college ranking and mentorship support for MD/MS/PG Diploma admissions.",
									"isPartOf": {
										"@id": "https://neetsupport.com/#website"
									},
									"about": [
										{ "@type": "Thing", "name": "NEET PG Counselling 2026" },
										{ "@type": "Thing", "name": "MD/MS Admission" },
										{ "@type": "Thing", "name": "PG Diploma Admission" },
										{ "@type": "Thing", "name": "Medical Counselling Committee (MCC)" },
										{ "@type": "Thing", "name": "State Counselling Authorities" }
									],
									"publisher": {
										"@id": "https://neetsupport.com/#organization"
									},
									"inLanguage": "en-IN"
								},
								{
									"@type": "Product",
									"@id": "https://neetsupport.com/neet-pg#product",
									"name": "NEET PG Counselling Tools & Mentorship",
									"description": "AI-powered cut-off & allotment tools with verified seat matrix, fees/stipend/bond comparisons, college comparison and 1:1 mentorship for NEET PG counselling.",
									"brand": {
										"@type": "Brand",
										"name": "NEET Support"
									},
									"offers": {
										"@type": "Offer",
										"url": "https://neetsupport.com/neet-pg",
										"priceCurrency": "INR",
										"price": "4999",
										"availability": "https://schema.org/InStock"
									}
								},
								{
									"@type": "FAQPage",
									"@id": "https://neetsupport.com/neet-pg#faq",
									"url": "https://neetsupport.com/neet-pg",
									"mainEntity": [
										{
											"@type": "Question",
											"name": "How do I check my NEET PG cut-off?",
											"acceptedAnswer": {
												"@type": "Answer",
												"text": "You can check previous years' cut-offs by year, round, course, institute, category, and quota using NEET PG data tools. Historical trends help plan choices more effectively."
											}
										},
										{
											"@type": "Question",
											"name": "How can I view available seats during counselling?",
											"acceptedAnswer": {
												"@type": "Answer",
												"text": "Use the real-time seat matrix to see seat availability for every round, institute, category, and quota so you can strategize your choices."
											}
										},
										{
											"@type": "Question",
											"name": "Where can I find details about fees, stipend, and bond conditions?",
											"acceptedAnswer": {
												"@type": "Answer",
												"text": "You can compare updated fees, stipend information, bond rules, and related institute details across quotas and courses using the platform tools."
											}
										},
										{
											"@type": "Question",
											"name": "How do I track past allotments?",
											"acceptedAnswer": {
												"@type": "Answer",
												"text": "Allotment data across years, states, rounds, and quotas can be reviewed to understand patterns and make informed preference lists."
											}
										},
										{
											"@type": "Question",
											"name": "What is Allotment Mapping?",
											"acceptedAnswer": {
												"@type": "Answer",
												"text": "Allotment Mapping helps you see how candidates near your rank moved across rounds and states, so you can identify realistic opportunities."
											}
										}
									]
								},
								{
									"@type": "BreadcrumbList",
									"@id": "https://neetsupport.com/neet-pg#breadcrumbs",
									"itemListElement": [
										{
											"@type": "ListItem",
											"position": 1,
											"name": "Home",
											"item": "https://neetsupport.com/"
										},
										{
											"@type": "ListItem",
											"position": 2,
											"name": "NEET PG",
											"item": "https://neetsupport.com/neet-pg"
										}
									]
								}
							]
						})
					}}
				/>
			</Head>
			<main className="mt-4">
				{/* Webinar Registration Modal */}
				{/* <WebinarModal 
					isOpen={showWebinarModal} 
					onClose={() => setShowWebinarModal(false)} 
				/> */}
				<OneToOneSession 
					isOpen={showOneToOneModal} 
					onClose={() => setShowOneToOneModal(false)} 
				/>

				<div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
					<HeroSection />
					{/* <BlackFridayOffer priceBasic={priceBasic} /> */}
				</div>

				<div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
					<Explore />
				</div>

				<div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
					<Plans />
				</div>

				<div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
					<Overview />
				</div>

				<div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
					<TestimonialCarousel />
				</div>

				<div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
					<BlogsVisible />
				</div>
				<div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
					<Faqs />
				</div>
			</main>
		</>
	);
}
